// Depends
import { route, group, subGroup, meta } from '@/helpers/routes'

import Create from './form/form'
import Index from './index/index'

const bookOccurrenceRoutes = [
  route('create', '/create', Create, meta('Adicionar Ocorrência', true, 'guest')),
  route('edit', '/:id/edit', Create, meta('Editar Ocorrência', true, 'guest')),
  route('index', '/index', Index, meta('Lista de ocorrências', true, 'guest'))
]

export default [
  ...group('/app', [
    ...subGroup('/book/occurrence', bookOccurrenceRoutes)
  ])
]



// WEBPACK FOOTER //
// ./src/app/dweller/book-occurrence/routes.js